'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import * as SupportSource from 'ecosystem-marketplace-core/constants/search/SupportSource';
import { getSupportSourceFilterI18nKey } from '../../../../utils/i18n';
import RadioInput from '../inputs/RadioInput';
const ALL = 'ALL';
const supportOrder = Immutable.OrderedSet([ALL, SupportSource.HUBSPOT, SupportSource.APP_PARTNER]);

const _getSupportSourceFilterI18nKey = supportSource => {
  switch (supportSource) {
    case ALL:
      return 'appMarketplace.storefront.filters.supportSource.items.all';

    default:
      return getSupportSourceFilterI18nKey(supportSource);
  }
};

const SupportSourceToggleGroup = ({
  onChange,
  value
}) => /*#__PURE__*/_jsx(UIToggleGroup, {
  name: "support-source",
  children: supportOrder.map(supportSource => /*#__PURE__*/_jsx(RadioInput, {
    checked: value ? supportSource === value : supportSource === ALL,
    onChange: ({
      target: {
        value: inputValue
      }
    }) => onChange(inputValue === ALL ? null : inputValue),
    value: supportSource,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: _getSupportSourceFilterI18nKey(supportSource)
    })
  }, supportSource))
});

SupportSourceToggleGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf([SupportSource.HUBSPOT, SupportSource.APP_PARTNER])
};
export default SupportSourceToggleGroup;